import { Navigate } from "react-router-dom";
import { getToken, isTokenValid } from "../services/authService";

export default function PrivateRoute({ children, logged = true }) {
  const isValidToken = isTokenValid();
  const token = getToken();

  // limpiar token si está vencido
  if (token && !isValidToken) {
    localStorage.removeItem("token");
  }

  // caso: ruta protegida y token válido
  if (logged && isValidToken) {
    return children;
  }

  // caso: ruta pública y token inválido
  if (!logged && !isValidToken) {
    return children;
  }

  const redirectTo = logged ? "/v1/admin/login" : "/v1/admin/dashboard";
  return <Navigate to={redirectTo} replace />;
}
